import React from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import useFetchCampaigns from '../../../hooks/admin/useFetchCampaigns';
import AdTable from '../components/AdTable';

const Index = () => {
  const { company } = useParams();
  const { columns, data, loading, error, refetch } = useFetchCampaigns({
    company,
  });
  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <h1>Error fetching data</h1>
      ) : (
        <AdTable
          data={data}
          columns={columns}
          font='campaña'
          refetch={refetch}
        />
      )}
    </div>
  );
};

export default Index;
